import React from "react";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import "./ProductCard.scss";

const ProductButton = (props: any) => {
  return (    
    <div className="pCardButtonsBlock">
      { 
        props.isDemoUser ? (
          props.buttonText && <Button aria-label={`${props.title}`} component={ Link } to={`/progress/${props.productId || ""}`} onClick={(e: any) => e.stopPropagation()} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.buttonText}</Button>
        ) : ( 
          props.buttonText && <Button aria-label={`${props.title}`} color="primary" variant="contained" size="medium" className="pCardButton pCardFlatButton">{props.buttonText}</Button>
        )
      }
    </div>
  )
}

export default ProductButton